export const supportedLocales = ["en", "fr", "es"];

export const localeNames = {
  en: "EN",
  fr: "FR",
  es: "ES",
};

export const translations = {
  en: {
    meta: {
      title: "imajnet | Infrastructure imagery platform by Imajing",
      description:
        "Access, explore and enrich georeferenced infrastructure imagery with imajnet, Imajing's web platform for field data sharing, asset management and infrastructure analysis.",
    },
    common: {
      brandLine: "web geo services",
      by: "by",
      menu: "Discover all the tools",
      close: "Close menu",
      home: "All tools",
      discover: "Discover",
      login: "Log in",
      contact: "Contact us",
      copyright: "imajing.",
    },
    home: {
      heroTitle: "Manage your infrastructure online",
      heroLogin: "Log in",
      accountsTitle: "Register",
      accounts: [
        {
          title: "Request a professional account",
          text: "Your company has subscribed to imajnet® webservice, please register with your professional e-mail address.",
          label: "Register",
          href: "https://imajnet.net/registration",
        },
        {
          title: "Forgot your password?",
          text: "",
          label: "Reset",
          href: "https://imajnet.net/forgotPassword",
        },
        {
          title: "Request a demo account",
          text: "Your company has not subscribed to imajnet® webservice but you want to test it, please register online and indicate “DEMO ROAD” or “DEMO TRAIN” in the the “Usage” field.",
          label: "Request a demo account",
          href: "https://imajnet.net/signup",
        },
      ],
      products: [
        {
          id: "gecko",
          eyebrow: "EXPLOIT THE IMAGERY",
          title: "imajnet® Gecko",
          text: "Production, sharing and Artificial Intelligence merged into one tool to manage your infrastructure.",
          emphasis: "Don't just explore your reality, enrich it.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F9b811a569d1c4869939f2c6406980c4e",
          imagePosition: "50% center",
          label: "Discover",
          href: "/en/gecko/",
        },
        {
          id: "lrs",
          eyebrow: "LOCALIZE ON THE FIELD",
          title: "imajnet® LRS App",
          text: "Get your location in linear coordinates with your phone.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F68e2f6cc86c049c4b52a907555f6e4b2",
          imagePosition: "50% center",
          links: [
            {
              label: "Download on Google Play",
              href: "https://play.google.com/store/apps/details?id=com.imajing.imajnet.LRSApp",
            },
            {
              label: "Download on App Store",
              href: "https://apps.apple.com/fr/app/imajnet-lrs-app/id1441002893",
            },
          ],
        },
        {
          id: "capture",
          eyebrow: "CAPTURE & ENRICH IMAGERY",
          title: "Imajing Capture",
          text: "Complete field surveys (on foot, by bike, car, or train) using only your smartphone.",
          emphasis: "Don't just explore your reality, enrich it.",
          image: "/media/imajing-capture.jpg",
          imagePosition: "50% center",
          label: "Get it on Google Play",
          href: "https://play.google.com/store/apps/details?id=com.imajing.imajing_capture",
        },
        {
          id: "qgis",
          eyebrow: "TO USE IN QGIS",
          title: "imajnet® QGiS plugin",
          text: "Discover the QGiS 3 plug-in from the standard QGiS plug-in repository.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F431136fe072340a1bd309345b9d85ea7",
          imagePosition: "10% center",
          label: "Download",
          href: "https://plugins.qgis.org/plugins/imajnet-qgis-plugin/",
        },
        {
          id: "esri",
          eyebrow: "TO INTEGRATE WITH ESRI",
          title: "imajnet® ESRI widget",
          text: "Discover the imajnet® widget for ArcGis online.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5357f6eac05e4693b0e424b908c5dbb2",
          imagePosition: "75% center",
          label: "Discover",
          href: "https://esri.imajnet.net/ImajnetWidgetDemo/",
        },
        {
          id: "sdk",
          eyebrow: "",
          title: "For other applications",
          text: "To develop and integrate in your own GIS and/or web app, discover the imajnet JavaScript SDK.",
          image: "/media/imajnet-sdk.png",
          imagePosition: "60% center",
          label: "Get the SDK",
          href: "https://www.imajnet.net/jssdk",
        },
      ],
    },
    gecko: {
      metaTitle: "imajnet Gecko | Infrastructure imagery and AI",
      metaDescription:
        "Measure, analyze and enrich georeferenced infrastructure imagery with imajnet Gecko, Imajing AI and collaborative GIS tools.",
      heroEyebrow: "",
      heroTitle: "WEB APPLICATION",
      login: "LOGIN",
      loginCta: "imajnet® Gecko - LOGIN",
      ctaIconLink: "https://imajing.eu/mobile-mapping-technologies/imajnet-web-geo-services/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=en_gecko_imajnet_web_geo",
      contact: "Contact us",
      intro: [
        "imajnet® is a safe and powerful featured web service giving access to nationwide surveys for any entity within an organization.",
        "It is designed to support transportation organizations' workflow with an access to up-to-date geo-referenced images anytime and anywhere, supporting asset management, maintenance and monitoring. Can serve any department within an organization for a simplified and more performing collaborative work.",
      ],
      pillars: [
        {
          title: "PRODUCTION",
          subtitle: "Data acquisition on the field for the team by the team",
          text: "imajnet® Gecko collects mobile mapping data from the field, whether it comes from surveys carried out with an Imajbox, the imajing Capture smartphone app, or events created via the imajnet® LRS App mobile application. This data helps enrich, centralize, and enhance the information produced through crowdsourcing.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5df27689fc84448cac9b5ae073e41a34?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F52697ea52cff420da8984728b8b07a98?format=webp&width=800&height=1200",
          ],
          logoStoreLinks: [
            {
              playStore: "https://play.google.com/store/apps/details?id=com.imajing.imajing_capture",
            },
            {
              playStore: "https://play.google.com/store/apps/details?id=com.imajing.imajnet.LRSApp",
              appStore: "https://apps.apple.com/fr/app/imajnet-lrs-app/id1441002893",
            },
          ],
          logoLabels: ["Imajing Capture", "LRS App"],
        },
        {
          title: "ARTIFICIAL INTELLIGENCE",
          subtitle: "From images to GIS",
          text: "imajnet® Gecko integrates artificial intelligence services able to search, localize in 3D and produce a structured base of the infrastructure.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fe4fa4ec5945f431b84786e08f35a59f1?format=webp&width=800&height=1200",
          ],
          logoLinks: [
            "https://imajing.eu/mobile-mapping-technologies/imajing-ai/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=en_gecko_imajing_ai",
          ],
          logoLabels: ["Imajing IA"],
        },
        {
          title: "SHARING",
          subtitle: "A platform designed for exchange and collaboration",
          text: "Make your data useful beyond your own work. Share coordinates and GIS data with your team, allowing colleagues to access, reuse, and benefit from your field insights and geospatial information.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F276e72f3daca4ba39924b10a90a875c1?format=webp&width=800&height=1200",
          ],
        },
      ],
      features: [
        {
          eyebrow: "",
          title: "AN ENRICHED RANGE OF TOOLS",
          items: [
            "Capture data through image area selection (ROI) or photogrammetric triangulation.",
            "Measure directly within images and create polygons across both images and maps.",
            "Pinpoint objects inside images, either manually or automatically with **imajing AI**, and connect them to geographic information.",
            "Enrich each object displayed on the map with pictures, PDFs, plans, or any other relevant documents.",
            "Manage, filter, and analyze your detections and mapped objects with ease using a dedicated data management tool.",
            "Export your databases in multiple formats for seamless integration with other GIS software.",
          ],
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F9a68701550d84a2ba8d2eec220bbb4dc",
          imagePosition: "20% center",
          carouselImages: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Ffb0d8d0c11954494bec18f188d11152d?format=webp&width=800&height=1200",
          ],
        },
        {
          eyebrow: "",
          title: "PRODUCTION & ARTIFICIAL INTELLIGENCE",
          intro: "An integrated workflow that brings together all key capabilities:",
          items: [
            "Field production with location tracking and imagery capture.",
            "AI-powered transformation of images into GIS data for infrastructure analysis and 3D positioning.",
            "Inventory of visible equipment directly from captured images.",
            "Road surface analysis to assess pavement conditions and prioritize renovation works.",
            "A seamless production-to-analysis workflow designed to turn field data into actionable geospatial insights.",
          ],
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F002a08b0043b494ba0276e47b7e37f59",
          imagePosition: "0% center",
          carouselImages: [
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5f1d72343bed4b8ca4ddc71dacc70a10?format=webp&width=800&height=1200",
              title: "Railway Railway Capture 1"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F30c2bcda3dbb466c975fce3fb1aadbdf",
              title: "Highway Network Analysis"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Ffb406f2220b8485fb06420be46d7fdfa",
              title: "Railway Railway Capture 2"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F8fcb216afd2342d3ade794ca7ea03b35",
              title: "Road Infrastructure Mapping"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F002a08b0043b494ba0276e47b7e37f59",
              title: "Railway Infrastructure Detection"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fabec2be4980645c3b97256fcd2e1bb17",
              title: "Urban Street Capture"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fc1d4a47759934a6c811b49a56247b0a6",
              title: "Railway Signal Detection"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F0e8cdbc57f9c46f5aa2fd42c96efaeea",
              title: "Imajnet AI & Immergis Capture"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F2e4b093f1fe34b83abaf26dc8a65867f",
              title: "Railway Infrastructure Scanning"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F292b33c257c4443abf4c0c4c88d0d209",
              title: "Vector Layers - Imajnet & Imajing AI"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5e940609cf9c41fdb8c1e569831687a9",
              title: "Railway Signal Processing"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fe84c8a0dda4e4da880dbd7d854db3e2c",
              title: "Infrastructure Analysis"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F0f90ba805b754ec1822b627d5ee0e972",
              title: "RailAI 2024 - AI for Railways"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F872ae7213067455490bef4fd1f0008e4",
              title: "AI Applied to Rail 2024"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F2fda8107029044929305f5b06016999c",
              title: "Imajing AI Railways"
            },
            {
              src: "/media/gecko-experience.png",
              title: "User Experience"
            },
          ],
        },
      ],
    },
  },
  fr: {
    meta: {
      title: "imajnet | Plateforme d'imagerie pour infrastructures par Imajing",
      description:
        "Accédez, explorez et exploitez l'imagerie géoréférencée de vos infrastructures avec imajnet, la plateforme web d'Imajing pour la gestion, le partage et l'analyse de données terrain.",
    },
    common: {
      brandLine: "services web géographiques",
      by: "par",
      menu: "Découvrir tous les outils",
      close: "Fermer le menu",
      home: "Tous les outils",
      discover: "Découvrir",
      login: "Connexion",
      contact: "Nous contacter",
      copyright: "imajing.",
    },
    home: {
      heroTitle: "Gérez vos infrastructures en ligne",
      heroLogin: "Se connecter",
      accountsTitle: "Inscription",
      accounts: [
        {
          title: "Demande de compte professionnel",
          text: "Si votre organisation a déjà souscrit au service web imajnet®, veuillez vous enregistrer avec votre adresse e-mail professionnelle.",
          label: "S'enregistrer",
          href: "https://imajnet.net/registration",
        },
        {
          title: "Vous avez oublié votre mot de passe ?",
          text: "",
          label: "Réinitialiser",
          href: "https://imajnet.net/forgotPassword",
        },
        {
          title: "Demande de compte démo",
          text: "Votre organisation n'a pas souscrit au web service imajnet® mais vous souhaitez le tester, veuillez vous enregistrer en ligne en indiquant \"DEMO ROAD\" ou \"DEMO TRAIN\" dans le champ \"Usage\".",
          label: "Demander un compte de démo",
          href: "https://imajnet.net/signup",
        },
      ],
      products: [
        {
          id: "gecko",
          eyebrow: "EXPLOITER L'IMAGERIE",
          title: "imajnet® Gecko",
          text: "Production, partage et Intelligence Artificielle fusionnés dans un même outil au service de la gestion de vos infrastructures.",
          emphasis: "Ne vous contentez pas d'explorer votre réalité, enrichissez-la.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F9b811a569d1c4869939f2c6406980c4e",
          imagePosition: "50% center",
          label: "Découvrir",
          href: "/fr/gecko/",
        },
        {
          id: "lrs",
          eyebrow: "SE LOCALISER SUR LE TERRAIN",
          title: "imajnet® LRS App",
          text: "Obtenez votre positionnement en coordonnées linéaires avec un smartphone.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F68e2f6cc86c049c4b52a907555f6e4b2",
          imagePosition: "50% center",
          links: [
            {
              label: "Obtenir - Google Play",
              href: "https://play.google.com/store/apps/details?id=com.imajing.imajnet.LRSApp",
            },
            {
              label: "Obtenir - App Store",
              href: "https://apps.apple.com/fr/app/imajnet-lrs-app/id1441002893",
            },
          ],
        },
        {
          id: "capture",
          eyebrow: "PRODUISEZ & ENRICHISSEZ L'IMAGERIE",
          title: "Imajing Capture",
          text: "Complétez les relevés sur le terrain (à pied, vélo, voiture, ou train) uniquement avec votre smartphone.",
          emphasis: "Ne vous contentez pas d'explorer votre réalité, enrichissez-la.",
          image: "/media/imajing-capture.jpg",
          imagePosition: "50% center",
          label: "Obtenir sur Google Play",
          href: "https://play.google.com/store/apps/details?id=com.imajing.imajing_capture",
        },
        {
          id: "qgis",
          eyebrow: "EXPLOITER L'IMAGERIE DANS L'ENVIRONNEMENT QGiS",
          title: "imajnet® plugin QGiS",
          text: "Découvrez le plug-in imajnet® pour QGiS 3 depuis le dépôt officiel des extensions QGiS.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F431136fe072340a1bd309345b9d85ea7",
          imagePosition: "60% center",
          label: "Téléchargement",
          href: "https://plugins.qgis.org/plugins/imajnet-qgis-plugin/",
        },
        {
          id: "esri",
          eyebrow: "EXPLOITER L'IMAGERIE DANS L'ENVIRONNEMENT ESRI",
          title: "imajnet® widget ESRI",
          text: "Découvrez le widget imajnet® pour ArcGis en ligne.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5357f6eac05e4693b0e424b908c5dbb2",
          imagePosition: "0% center",
          label: "Découvrir",
          href: "https://esri.imajnet.net/ImajnetWidgetDemo/",
        },
        {
          id: "sdk",
          eyebrow: "",
          title: "Intégrez imajnet® dans vos applications avec le SDK.",
          text: "Pour développer et intégrer vos propres données SIG et/ou application web, découvrez le SDK JavaScript pour imajnet.",
          image: "/media/imajnet-sdk.png",
          imagePosition: "60% center",
          label: "Obtenir le SDK",
          href: "https://www.imajnet.net/jssdk",
        },
      ],
    },
    gecko: {
      metaTitle: "imajnet Gecko | Imagerie et IA pour les infrastructures",
      metaDescription:
        "Mesurez, analysez et enrichissez l'imagerie géoréférencée de vos infrastructures avec imajnet Gecko, Imajing AI et des outils SIG collaboratifs.",
      heroEyebrow: "",
      heroTitle: "APPLICATION WEB",
      login: "CONNEXION",
      loginCta: "imajnet® Gecko - CONNEXION",
      ctaIconLink: "https://imajing.eu/fr/technologies-cartographie-mobile/imajnet-web-geo-services/",
      contact: "CONTACTEZ-NOUS",
      intro: [
        "imajnet® est un service web sûr et performant conçu pour aider les gestionnaires d'infrastructures à organiser leurs travaux d'inventaire, de maintenance et d'entretien grâce à un accès à des données à jour, géo-référencées et partagées, n'importe où et n'importe quand.",
        "imajnet® fournit de l'information à toute organisation et les entités qui la composent, assurant ainsi une meilleure productivité pour un travail collaboratif simplifié et plus performant.",
      ],
      pillars: [
        {
          title: "PRODUCTION",
          subtitle: "Acquisition de données sur le terrain par l'équipe pour l'équipe",
          text: "imajnet® Gecko collecte les données de mobile mapping issues du terrain, qu'elles proviennent de relevés réalisés avec une Imajbox, de l'application smartphone imajing Capture, ou d'événements créés via l'application mobile imajnet® LRS App. Ces données permettent d'enrichir, de centraliser et de valoriser les informations produites par crowdsourcing.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5df27689fc84448cac9b5ae073e41a34?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F52697ea52cff420da8984728b8b07a98?format=webp&width=800&height=1200",
          ],
          logoStoreLinks: [
            {
              playStore: "https://play.google.com/store/apps/details?id=com.imajing.imajing_capture",
            },
            {
              playStore: "https://play.google.com/store/apps/details?id=com.imajing.imajnet.LRSApp",
              appStore: "https://apps.apple.com/fr/app/imajnet-lrs-app/id1441002893",
            },
          ],
          logoLabels: ["Imajing Capture", "LRS App"],
        },
        {
          title: "INTELLIGENCE ARTIFICIELLE",
          subtitle: "De l'image au SIG",
          text: "imajnet® Gecko intègre des services d'intelligence artificielle capables de rechercher, de localiser en 3D et de produire une base structurée de l'infrastructure.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fe4fa4ec5945f431b84786e08f35a59f1?format=webp&width=800&height=1200",
          ],
          logoLinks: [
            "https://imajing.eu/fr/technologies-cartographie-mobile/imajing-ai/",
          ],
          logoLabels: ["Imajing IA"],
        },
        {
          title: "PARTAGE",
          subtitle: "Une plateforme pensée pour l'échange et la collaboration",
          text: "Rendez vos données utiles au-delà de votre propre travail. Partagez les coordonnées et les données SIG avec votre équipe, permettant à vos collègues d'accéder, de réutiliser et de bénéficier de vos observations de terrain et de vos informations géospatiales.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F276e72f3daca4ba39924b10a90a875c1?format=webp&width=800&height=1200",
          ],
        },
      ],
      features: [
        {
          eyebrow: "",
          title: "UNE GAMME D'OUTILS ENRICHIE",
          items: [
            "Saisissez des données par sélection d'une zone dans l'image (ROI) ou par triangulation photogrammétrique.",
            "Mesurez directement dans les images et créez des polygones à la fois sur les images et les cartes.",
            "Localisez des objets dans les images, manuellement ou automatiquement avec **imajing AI**, et reliez-les aux informations géographiques.",
            "Enrichissez chaque objet affiché sur la carte avec des photos, PDF, plans ou tout autre document pertinent.",
            "Gérez, filtrez et analysez facilement vos détections et objets cartographiés grâce à un outil de gestion de données dédié.",
            "Exportez vos bases de données dans de multiples formats pour une intégration fluide avec d'autres logiciels SIG.",
          ],
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F9a68701550d84a2ba8d2eec220bbb4dc",
          imagePosition: "20% center",
          carouselImages: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5b7a25272aa641bcb84a202d8c98fefb?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fe0cda4dad6da4dda939fe58ffcbbb7de?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F54c97b4f31d34df88be4e525bb7188e0?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fa3e598605c6740d6afdde01c55d2ecba?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F66b4a0e63c4c49aaa3f2bbafd624b6ac?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F0f81ecdec66c430b9896d84166baf5c7?format=webp&width=800&height=1200",
          ],
        },
        {
          eyebrow: "",
          title: "PRODUCTION & INTELLIGENCE ARTIFICIELLE",
          intro: "Un flux de travail intégré qui réunit toutes les capacités clés :",
          items: [
            "Production sur le terrain avec suivi de localisation et capture d'imagerie.",
            "Transformation des images en données SIG par l'IA pour l'analyse des infrastructures et le positionnement 3D.",
            "Inventaire des équipements visibles directement à partir des images capturées.",
            "Analyse de l'état des chaussées pour évaluer leur condition et prioriser les travaux de rénovation.",
            "Un flux de travail fluide de la production à l'analyse, conçu pour transformer les données de terrain en informations géospatiales exploitables.",
          ],
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F002a08b0043b494ba0276e47b7e37f59",
          imagePosition: "0% center",
          carouselImages: [
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5f1d72343bed4b8ca4ddc71dacc70a10?format=webp&width=800&height=1200",
              title: "Capture Imajnet Ferroviaire 1"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F30c2bcda3dbb466c975fce3fb1aadbdf",
              title: "Analyse Réseau Routier"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Ffb406f2220b8485fb06420be46d7fdfa",
              title: "Capture Imajnet Ferroviaire 2"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F8fcb216afd2342d3ade794ca7ea03b35",
              title: "Cartographie Infrastructure Routière"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F002a08b0043b494ba0276e47b7e37f59",
              title: "Détection Infrastructures Ferroviaires"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fabec2be4980645c3b97256fcd2e1bb17",
              title: "Capture Rue Urbaine"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fc1d4a47759934a6c811b49a56247b0a6",
              title: "Détection Feu Ferroviaire"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F0e8cdbc57f9c46f5aa2fd42c96efaeea",
              title: "Capture Imajnet IA et Immergis"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F2e4b093f1fe34b83abaf26dc8a65867f",
              title: "Balayage Infrastructure Ferroviaire"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F292b33c257c4443abf4c0c4c88d0d209",
              title: "Couches Vectorielles - Imajnet & Imajing IA"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5e940609cf9c41fdb8c1e569831687a9",
              title: "Traitement Feu Ferroviaire"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fe84c8a0dda4e4da880dbd7d854db3e2c",
              title: "Analyse Infrastructure"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F0f90ba805b754ec1822b627d5ee0e972",
              title: "RailAI 2024 - IA pour les Voies"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F872ae7213067455490bef4fd1f0008e4",
              title: "IA Appliquée aux Voies 2024"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F2fda8107029044929305f5b06016999c",
              title: "Imajing IA Ferroviaires"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F33561f80e0da4a0c94257fb1d500f294?format=webp&width=800&height=1200",
              title: "Détails de l'objet"
            },
            {
              src: "/media/gecko-experience.png",
              title: "Expérience Utilisateur"
            },
          ],
        },
      ],
    },
  },
  es: {
    meta: {
      title: "imajnet | Plataforma de imágenes para infraestructuras de Imajing",
      description:
        "Acceda, explore y enriquezca imágenes georreferenciadas de infraestructuras con imajnet, la plataforma web de Imajing para compartir, gestionar y analizar datos de campo.",
    },
    common: {
      brandLine: "servicios web geográficos",
      by: "por",
      menu: "Todas las herramientas",
      close: "Cerrar el menú",
      home: "Todas las herramientas",
      discover: "Descubrir",
      login: "Acceder",
      contact: "Contacto",
      copyright: "imajing.",
    },
    home: {
      heroTitle: "Gestione su infraestructura en línea",
      heroLogin: "Iniciar sesión",
      accountsTitle: "Registrarse",
      accounts: [
        {
          title: "Solicitar una cuenta profesional",
          text: "Su empresa se ha suscrito al servicio web imajnet®, regístrese con su correo electrónico profesional.",
          label: "Registrarse",
          href: "https://imajnet.net/registration",
        },
        {
          title: "Olvidaste tu contraseña ?",
          text: "",
          label: "Reiniciar",
          href: "https://imajnet.net/forgotPassword",
        },
        {
          title: "Solicitar una cuenta de demo",
          text: "Su empresa no se ha suscrito al servicio web imajnet®, pero quieres probarlo. Regístrese en línea e indique \"DEMO ROAD\" o \"DEMO TRAIN\" en el campo \"Uso\".",
          label: "Solicitar una cuenta de demo",
          href: "https://imajnet.net/signup",
        },
      ],
      products: [
        {
          id: "gecko",
          eyebrow: "",
          title: "imajnet® Gecko",
          text: "Producción, compartición e Inteligencia Artificial fusionadas en una única herramienta para gestionar su infraestructura.",
          emphasis: "No te limites a explorar tu realidad, enriquécela.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F9b811a569d1c4869939f2c6406980c4e",
          imagePosition: "50% center",
          label: "Descubrir",
          href: "/es/gecko/",
        },
        {
          id: "lrs",
          eyebrow: "LOCALIZAR EN EL CAMPO",
          title: "imajnet® LRS App",
          text: "Obtenga su posición en coordenadas lineales con un teléfono.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F68e2f6cc86c049c4b52a907555f6e4b2",
          imagePosition: "50% center",
          links: [
            {
              label: "Obtener en Google Play",
              href: "https://play.google.com/store/apps/details?id=com.imajing.imajnet.LRSApp",
            },
            {
              label: "Obtener en App Store",
              href: "https://apps.apple.com/fr/app/imajnet-lrs-app/id1441002893",
            },
          ],
        },
        {
          id: "capture",
          eyebrow: "CAPTURA Y ENRIQUECE LAS IMÁGENES",
          title: "Imajing Capture",
          text: "Completa los trabajos de campo (a pie, en bicicleta, en coche o en tren) utilizando únicamente tu smartphone.",
          emphasis: "No te limites a explorar tu realidad, enriquécela.",
          image: "/media/imajing-capture.jpg",
          imagePosition: "50% center",
          label: "Obtener en Google Play",
          href: "https://play.google.com/store/apps/details?id=com.imajing.imajing_capture",
        },
        {
          id: "qgis",
          eyebrow: "PARA USAR EN QGiS",
          title: "imajnet® QGiS plugin",
          text: "Descubra el plug-in QGiS 3 desde el repositorio oficiel de QGiS.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F431136fe072340a1bd309345b9d85ea7",
          imagePosition: "10% center",
          label: "Descargar",
          href: "https://plugins.qgis.org/plugins/imajnet-qgis-plugin/",
        },
        {
          id: "esri",
          eyebrow: "INTEGRAR CON ESRI",
          title: "imajnet® ESRI widget",
          text: "Descubrir el widget imajnet® para ArcGis en línea.",
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5357f6eac05e4693b0e424b908c5dbb2",
          imagePosition: "8% center",
          label: "Descubrir",
          href: "https://esri.imajnet.net/ImajnetWidgetDemo/",
        },
        {
          id: "sdk",
          eyebrow: "",
          title: "Para otras aplicaciones",
          text: "Para desarrollar e integrar en su propio SIG y / o aplicación web, descubra el SDK de JavaScript de imajnet.",
          image: "/media/imajnet-sdk.png",
          imagePosition: "60% center",
          label: "Obtener el SDK",
          href: "https://www.imajnet.net/jssdk",
        },
      ],
    },
    gecko: {
      metaTitle: "imajnet Gecko | Imágenes e IA para infraestructuras",
      metaDescription:
        "Mida, analice y enriquezca imágenes georreferenciadas de infraestructuras con imajnet Gecko, Imajing AI y herramientas SIG colaborativas.",
      heroEyebrow: "",
      heroTitle: "Aplicación web",
      login: "ACCEDER",
      loginCta: "imajnet® Gecko - ACCEDER",
      ctaIconLink: "https://imajing.eu/es/tecnologias-cartografia-movil/servicio-web-imajnet/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=es_gecko_imajnet_web_geo",
      contact: "CONTACT",
      intro: [
        "imajnet® es un servicio web seguro y eficiente diseñado para ayudar a las empresas/organizaciones a organizar su trabajo de inventario, mantenimiento y servicio a través del acceso a datos actualizados, georreferenciados y compartidos.",
        "imajnet® ofrece información a cualquier organización y a las entidades que la componen, garantizando una mayor productividad.",
      ],
      pillars: [
        {
          title: "PRODUCCIÓN",
          subtitle: "Adquisición de datos en el campo para el equipo por el equipo",
          text: "imajnet® Gecko recopila datos de mobile mapping del terreno, ya provengan de levantamientos realizados con una Imajbox, de la aplicación para smartphone imajing Capture, o de eventos creados a través de la aplicación móvil imajnet® LRS App. Estos datos permiten enriquecer, centralizar y valorizar la información producida mediante crowdsourcing.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5df27689fc84448cac9b5ae073e41a34?format=webp&width=800&height=1200",
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F52697ea52cff420da8984728b8b07a98?format=webp&width=800&height=1200",
          ],
          logoStoreLinks: [
            {
              playStore: "https://play.google.com/store/apps/details?id=com.imajing.imajing_capture",
            },
            {
              playStore: "https://play.google.com/store/apps/details?id=com.imajing.imajnet.LRSApp",
              appStore: "https://apps.apple.com/es/app/imajnet-lrs-app/id1441002893",
            },
          ],
          logoLabels: ["Imajing Capture", "LRS App"],
        },
        {
          title: "INTELIGENCIA ARTIFICIAL",
          subtitle: "De imágenes a SIG",
          text: "imajnet® Gecko integra servicios de inteligencia artificial con el objetivo de buscar, posicionar en 3D y producir una base estructurada de su infraestructura.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fe4fa4ec5945f431b84786e08f35a59f1?format=webp&width=800&height=1200",
          ],
          logoLinks: [
            "https://imajing.eu/mobile-mapping-technologies/imajing-ai/?utm_source=imajnet.net&utm_medium=referral&utm_campaign=es_gecko_imajing_ai",
          ],
          logoLabels: ["Imajing IA"],
        },
        {
          title: "INTERCAMBIO DE INFORMACIÓN",
          subtitle: "Una plataforma diseñada para el intercambio y la colaboración",
          text: "Haga que sus datos sean útiles más allá de su propio trabajo. Comparta coordenadas y datos SIG con su equipo, permitiendo que sus colegas accedan, reutilicen y se beneficien de sus observaciones de campo e información geoespacial.",
          logos: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F276e72f3daca4ba39924b10a90a875c1?format=webp&width=800&height=1200",
          ],
        },
      ],
      features: [
        {
          eyebrow: "",
          title: "UNA GAMA DE HERRAMIENTAS ENRIQUECIDA",
          items: [
            "Capture datos mediante la selección de una zona en la imagen (ROI) o por triangulación fotogramétrica.",
            "Mida directamente en las imágenes y cree polígonos tanto en imágenes como en mapas.",
            "Localice objetos dentro de las imágenes, manualmente o automáticamente con **imajing AI**, y conéctelos con la información geográfica.",
            "Enriquezca cada objeto mostrado en el mapa con fotos, PDF, planos o cualquier otro documento relevante.",
            "Gestione, filtre y analice fácilmente sus detecciones y objetos cartografiados con una herramienta de gestión de datos dedicada.",
            "Exporte sus bases de datos en múltiples formatos para una integración fluida con otros programas SIG.",
          ],
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F9a68701550d84a2ba8d2eec220bbb4dc",
          imagePosition: "20% center",
          carouselImages: [
            "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Ffb0d8d0c11954494bec18f188d11152d?format=webp&width=800&height=1200",
          ],
        },
        {
          eyebrow: "",
          title: "PRODUCCIÓN E INTELIGENCIA ARTIFICIAL",
          intro: "Un flujo de trabajo integrado que reúne todas las capacidades clave:",
          items: [
            "Producción de campo con seguimiento de ubicación y captura de imágenes.",
            "Transformación de imágenes en datos SIG mediante IA para el análisis de infraestructuras y el posicionamiento 3D.",
            "Inventario de equipamiento visible directamente a partir de las imágenes capturadas.",
            "Análisis del estado del pavimento para evaluar su condición y priorizar los trabajos de renovación.",
            "Un flujo de trabajo fluido de la producción al análisis, diseñado para convertir los datos de campo en información geoespacial procesable.",
          ],
          image: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F002a08b0043b494ba0276e47b7e37f59",
          imagePosition: "0% center",
          carouselImages: [
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5f1d72343bed4b8ca4ddc71dacc70a10?format=webp&width=800&height=1200",
              title: "Captura Imajnet Ferroviaria 1"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F30c2bcda3dbb466c975fce3fb1aadbdf",
              title: "Análisis Red Vial"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Ffb406f2220b8485fb06420be46d7fdfa",
              title: "Captura Imajnet Ferroviaria 2"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F8fcb216afd2342d3ade794ca7ea03b35",
              title: "Cartografía Infraestructura Vial"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F002a08b0043b494ba0276e47b7e37f59",
              title: "Detección Infraestructuras Ferroviarias"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fabec2be4980645c3b97256fcd2e1bb17",
              title: "Captura Calle Urbana"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fc1d4a47759934a6c811b49a56247b0a6",
              title: "Detección Semáforo Ferroviario"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F0e8cdbc57f9c46f5aa2fd42c96efaeea",
              title: "Captura Imajnet IA e Immergis"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F2e4b093f1fe34b83abaf26dc8a65867f",
              title: "Escaneo Infraestructura Ferroviaria"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F292b33c257c4443abf4c0c4c88d0d209",
              title: "Capas Vectoriales - Imajnet & Imajing IA"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F5e940609cf9c41fdb8c1e569831687a9",
              title: "Procesamiento Semáforo Ferroviario"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2Fe84c8a0dda4e4da880dbd7d854db3e2c",
              title: "Análisis Infraestructura"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F0f90ba805b754ec1822b627d5ee0e972",
              title: "RailAI 2024 - IA para Ferrocarriles"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F872ae7213067455490bef4fd1f0008e4",
              title: "IA Aplicada a Ferrocarriles 2024"
            },
            {
              src: "https://cdn.builder.io/api/v1/image/assets%2Fffd4b999daf14b9eb6353196fcc0d951%2F2fda8107029044929305f5b06016999c",
              title: "Imajing IA Ferroviarios"
            },
            {
              src: "/media/gecko-experience.png",
              title: "Experiencia de Usuario"
            },
          ],
        },
      ],
    },
  },
};
